import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Store } from 'vuex'
import RootState from '../../store/state'
import { CategoryData } from '../../store/manager/state'
import { MAX_TITLE_LENGTH, RECOMMENDED_TITLE_LENGTH } from '../constants/TitleLength'
import { ContentItem } from '../../api/gerbera/contents'
import { Watch } from 'vue-property-decorator'
import { Getters } from '../../store/manager/helpers'

@Component({
  props: {
    articleData: {
      type: Object, /* ArticleData */
      required: true
    }
  }
})
export default class PublishConfig extends Vue {
  name: 'PublishConfig'
  $store: Store<RootState>
  readonly articleData: ContentItem
  categoryId: number | null = null
  title: string = ''

  get siteId(): number {
    return Getters.getAcountData(this.$store).kajikiId
  }

  get editContentListPage(): string {
    return process.env.MEKAJIKI_MANAGE_BASE_URL + 'editContentListPageForCm?kajikiId=' + this.siteId
  }

  get maxTitleLength(): number {
    return MAX_TITLE_LENGTH
  }

  get recommendedTitleLength(): number {
    return RECOMMENDED_TITLE_LENGTH
  }

  get hasValidTitle(): boolean {
    return !!this.title && this.title.length <= this.maxTitleLength
  }

  get hasValidCategory(): boolean {
    return _.some(this.categoryData, data => data.categoryId === this.categoryId)
  }

  get unsubmittable(): boolean {
    return !this.hasValidCategory
  }

  get categoryData(): CategoryData[] {
    return this.$store.state.manager.categoryData
  }

  mounted(): void {
    this.initialize()
  }

  @Watch('articleData')
  initialize(): void {
    const article = this.articleData
    const category = article.category || {}
    this.title = article.title || ''
    this.categoryId = category.categoryId || null
  }

  submitEvent() {
    const submitConfigData = {
      category: {
        categoryId: this.categoryId
      },
      title: this.title
    }
    return this.$emit('submit', submitConfigData)
  }

  close() {
    return this.$emit('close')
  }

  trackTitle(): void {
  }

  trackCategory(): void {
  }
}
